import React, { useState, useEffect, useMemo } from "react";
import { TextFieldWrapper } from "@factorearth/component-library";
import { Colors } from "@factorearth/component-library/dist/Theme/types";
import { Button } from "@factorearth/component-library";
import { useTheme } from "hooks/useSingleton";
interface ActionElement {
	delimiter: "CHARCODE_31" | string;
	elements: ActionElement[];
	target: string;
	num: number;
	requirements: string;
	description: string;
	requirementInstructions: string;
	data: string[];
	type: "exportData" | "actionData";
	allowedTypes: string[];
}

interface Props {
	actionElement: ActionElement;
	handleBlur: React.MouseEventHandler<HTMLButtonElement>;
	handleChange: (fakeEvent: { target: { value: string } }) => void;
	value: string;
	colorPalette: Colors & string;
}

function TextInputList(props: Props) {
	const { actionElement, handleBlur, handleChange, value, colorPalette } = props;
	const [listItems, setListItems] = useState<string[]>([]);
	const [input, setInput] = useState<string>("");
	const color = useTheme();

	useEffect(() => {
		if (value) {
			const items = value.split(actionElement.delimiter === "CHARCODE_31" ? String.fromCharCode(31) : actionElement.delimiter);
			setListItems(items);
		} else {
			setListItems([]);
		}
	}, [value]);

	const listItemHtml = useMemo(() => {
		function deleteListItem(index: number) {
			const finalItems = listItems.filter((val, i) => {
				if (index !== i) return val;
			});
			const finalString = finalItems.length > 0 ? finalItems.join(String.fromCharCode(31)) : "";
			const fakeEvent = {
				target: {
					value: finalString,
				},
			};
			handleChange(fakeEvent);
		}
		return listItems.length > 0 ? (
			<ol>
				{listItems.map((item, index) => (
					<li key={item}>
						{item} <Button colorPalette={color} onClick={() => deleteListItem(index)} variant="destructive" label="Delete" />
					</li>
				))}
			</ol>
		) : null;
	}, [listItems, handleChange]);

	function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
		setInput(event.target.value);
	}

	function handleClick(_event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		const finalString = value ? `${value}${String.fromCharCode(31)}${input}` : input;
		const fakeEvent = {
			target: {
				value: finalString,
			},
		};
		handleChange(fakeEvent);
		setInput("");
	}

	return (
		<div>
			{listItemHtml}
			<TextFieldWrapper type="text" value={input} onChange={handleInputChange} colorPalette={colorPalette} />
			<Button colorPalette={color} onClick={handleClick} variant="filled">
				Add to list
			</Button>
			<Button colorPalette={color} onClick={handleBlur} variant="filled">
				Submit
			</Button>
		</div>
	);
}

export default TextInputList;
